<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="8">
        <v-card>
          <v-card-title>
            <v-icon large>mdi-account-edit</v-icon>
            <h3>{{ $tt('customUserSettings') }}</h3>
          </v-card-title>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-card-text>
              <h4>ID(Email)</h4>
              <p>
                {{ email }}
                <span v-if="userGroups"> / UserGroups: {{ userGroups }} </span>
              </p>
              <h4>{{ $tt('customIconSettings') }}</h4>
              <p>
                <user-icon-component size="50" :showNickname="false" :iconUrl="iconUrl" />
                <v-btn :to="{ name: 'UserIcon' }" class="change-icon-btn text-none" outlined color="success">{{
                  $tt('customChange')
                }}</v-btn>
              </p>
              <v-row>
                <v-col cols="5">
                  <h4>{{ $tt('customLanguage') }}</h4>
                  <v-select
                    v-model="userLanguage"
                    item-value="value"
                    item-text="name"
                    :items="languages"
                    @change="saveLang(userLanguage)"
                  >
                  </v-select>
                </v-col>
              </v-row>
              <h4>{{ $tt('UnitTitle') }}</h4>
              <v-radio-group v-model="systemOfUnits" row>
                <v-radio :label="$tt('UnitMetric')" value="Metric" />
                <v-radio :label="$tt('UnitImperial')" value="Imperial" />
                <v-radio :label="$tt('UnitJpUnitsOfArea')" value="JpUnitsOfArea" />
                <v-radio :label="$tt('UnitThUnitsOfArea')" value="ThUnitsOfArea" />
              </v-radio-group>
              <v-text-field
                v-model="nickname"
                :error-messages="nicknameErrors"
                :label="$tt('NickNameHint')"
                @input="$v.nickname.$touch()"
                @blur="$v.nickname.$touch()"
                required
              />
              <v-checkbox :label="$tt('SendMeNews')" v-model="sendMeNews" />
              <!-- TODO アカウント削除機能実装 -->
              <!-- <a href="#" class="delete-memberInfo-btn">アカウント削除（フリープランの退会）</a> -->
            </v-card-text>
            <v-card-actions>
              <v-btn
                type="submit"
                color="primary"
                class="white--text text-none"
                :disabled="!valid"
                @click.stop.prevent="updateUser"
              >
                {{ $tt('customSaveAction') }}
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
      <v-footer fixed>
        <footer-component />
      </v-footer>
    </v-row>
  </v-container>
</template>

<script>
import UserIconComponent from '@/components/user/UserIconComponent'
import * as Filters from '@/lib/filters'
import i18n from '@/lib/i18n'
import storage from '@/lib/storage'
import UserGroupsInfo from '@/lib/user-groups-info'
import UserInfo from '@/lib/user-info'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import FooterComponent from '@/components/FooterComponent'

export default {
  name: 'UserSetting',
  components: { UserIconComponent, FooterComponent },

  mixins: [validationMixin],
  validations: {
    nickname: { required },
  },
  mounted() {
    this.getMe()
  },

  data() {
    const userInfo = storage.getUserInfo()
    return {
      email: userInfo.email,
      nickname: userInfo.nickname,
      sendMeNews: userInfo.sendMeNews,
      userLanguage: i18n.getUserLang(),
      systemOfUnits: userInfo.systemOfUnits, // UserSettingの画面を開くタイミングではstoreにまだセットされていないため変更
      valid: true,
      languages: [
        { name: '日本語', value: 'ja' },
        { name: 'English', value: 'en' },
        { name: 'Português', value: 'pt' },
        { name: 'Espanol', value: 'es' },
        { name: 'Deutsch', value: 'de' },
        { name: 'Polski', value: 'pl' },
        { name: 'Pусский', value: 'ru' },
        { name: 'ภาษาไทย', value: 'th' },
      ],
    }
  },

  methods: {
    updateUser() {
      const userData = {
        nickname: this.nickname,
        sendMeNews: this.sendMeNews,
        language: this.userLanguage,
        systemOfUnits: this.systemOfUnits,
      }
      this.$store.dispatch('authUpdateUser', userData)
    },
    saveLang(lang) {
      i18n.setUserLangByLanguage(lang)
    },
    saveUnit(unit) {
      this.$store.dispatch('setSystemOfUnits', unit)
    },
    getMe() {
      this.$store.dispatch('authGetMe')
    },
  },

  computed: {
    iconUrl: function() {
      return UserInfo.getIconUrl()
    },
    nicknameErrors() {
      const errors = []
      if (!this.$v.nickname.$dirty) return errors
      !this.$v.nickname.required && errors.push(this.$tt('ValidationTextRequired'))
      return errors
    },
    userGroups() {
      const groupNames = UserGroupsInfo.groupNames()
      if (groupNames.length > 0) {
        return groupNames.join(',')
      }
      return null
    },
  },
}
</script>

<style scoped>
.change-icon-btn {
  margin-left: 20px;
}
.delete-account-btn {
  color: red;
}
</style>
